import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_VISUAL_LANGUAGE } from './schema';

const MUTATION = gql`
  mutation CreateVisualLanguage($customerId: ID!, $workspaceId: ID, $name: String!) {
    createVisualLanguage(name: $name, customerId: $customerId, workspaceId: $workspaceId) {
      ...VisualLanguage
    }
  }
  ${FRAGMENT_VISUAL_LANGUAGE}
`;

export const createVisualLanguage = async ({ customerId, workspaceId, name }) => {
  const variables = {
    name,
    customerId,
    workspaceId,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
